import dayjs from "dayjs";
import * as yup from "yup";

export const DEFAULT_VALUES = {
  transactionDate: dayjs(),
  seller: null,
  buyer: null,
  buyerableType: null,
  warehouse: null,
  note: "",
  customerClaimProductVariants: [],
};

export const VALIDATION_SCHEMA = yup.object().shape({
  transactionDate: yup.date().required("Tanggal transaksi harus diisi"),
  seller: yup.object().required("Outlet harus diisi").nullable(),
  buyer: yup.object().required("Pelanggan harus diisi").nullable(),
  buyerableType: yup.string().required("Jenis pembeli harus diisi"),
  warehouse: yup.object().required("Gudang harus diisi").nullable(),
  note: yup.string(),
  customerClaimProductVariants: yup
    .array()
    .of(
      yup.object().shape({
        productId: yup.string().required(),
        name: yup.string().required(),
        sku: yup.string().required(),
        quantity: yup.number().min(1, "Kuantitas minimal 1").required(),
        note: yup.string(),
      })
    )
    .min(1, "Minimal 1 varian produk harus ditambahkan"),
});
